export class HuntGroupMember {
    id: number;
    number: string;
    name: string;
    priority: number;
}
